// removed by extract-text-webpack-plugin
module.exports = {"options":"src-modules-accommodation-AccommodationSchedulerView-__PricingPlansField__options--AwGEa","option":"src-modules-accommodation-AccommodationSchedulerView-__PricingPlansField__option--3N5NU"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/accommodation/AccommodationSchedulerView/PricingPlansField.less
// module id = 1873
// module chunks = 0